import React from 'react';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';
import { Formik, Form, Field, CccisdInput } from 'cccisd-formik';

const Boilerplate = window.cccisd.boilerplate;

const EditRespondent = ({ row, closeModal, onSuccess }) => {
    const handleSubmit = async values => {
        try {
            const payload = {
                username: values.username,
                first_name: values.firstName,
                last_name: values.lastName,
                pawnHash: row.pawnHash,
                passcode: row.passcode,
                role: 'respondent',
                activate: false,
                group: row.group,
            };

            const response = await axios.put(
                Boilerplate.route('api.nexus.pawn.update', {
                    pawn: row.pawnId,
                }),
                payload
            );

            if (response?.data?.errors) {
                throw response.data.errors;
            }

            if (closeModal) {
                closeModal();
            }

            if (onSuccess) {
                await onSuccess();
            }

            notification({
                message: 'Respondent details updated successfully.',
                type: 'success',
            });
        } catch (error) {
            let errorMessage = 'Unable to update respondent details.';

            if (error instanceof Error) {
                errorMessage = error.message;
            } else if (Array.isArray(error)) {
                errorMessage = error.join(', ');
            } else if (error && typeof error === 'object') {
                errorMessage = Object.values(error).join(', ');
            }

            notification({ message: errorMessage, type: 'danger' });
            throw error;
        }

        return values;
    };

    const validate = values => {
        const errors = {};
        if (!values.firstName) {
            errors.firstName = 'First name is required';
        }
        if (!values.lastName) {
            errors.lastName = 'Last name is required';
        }
        return errors;
    };

    return (
        <Formik
            initialValues={{
                username: row.username || '',
                firstName: row.firstName || '',
                lastName: row.lastName || '',
            }}
            onSubmit={handleSubmit}
            validate={validate}
            render={({ isSubmitting }) => (
                <Form>
                    <div className="form-group">
                        <label htmlFor="edit-username">Username</label>
                        <Field id="edit-username" name="username" type="text" component={CccisdInput} disabled />
                    </div>

                    <div className="form-group">
                        <label htmlFor="edit-firstName">First Name</label>
                        <Field id="edit-firstName" name="firstName" type="text" component={CccisdInput} />
                    </div>

                    <div className="form-group">
                        <label htmlFor="edit-lastName">Last Name</label>
                        <Field id="edit-lastName" name="lastName" type="text" component={CccisdInput} />
                    </div>

                    <div className="d-flex justify-content-between" style={{ marginTop: '15px' }}>
                        <button className="btn btn-secondary" type="button" onClick={closeModal}>
                            Cancel
                        </button>
                        <button className="btn btn-primary" type="submit" disabled={isSubmitting}>
                            Save
                        </button>
                    </div>
                </Form>
            )}
        />
    );
};

export default EditRespondent;
